export default {
  methods: {
    filterListByMultipleProps(array, props) {
      return array.filter(object => {
        var includes = false;
        props.forEach(filter => {
          if (!!filter) {
            var val = this.getObjectPath(filter, object)
            if (!!val) {
              var match = val.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
              if (match) includes = true;
            }
          }
        })
        return includes;
      });
    }
  }
}